module.exports = __webpack_public_path__ + "img/angular-logo.abfc3b93.svg";